import { NeoModel, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class FileGroupingFileSpecImportProcedureCriteria extends ValueObject {

    public searchCriteria: string = "";

    public serviceProviderGroupingName: string = "";

    public staticServiceProviderFileGroupingID: number | null = null;

    public staticFileSpecID: number | null = null;

    public fileTypeConcatenated: string | null = null;
}